// Production values
export const environment = {
  googleMapsApiKey: 'AIzaSyAOVYRIgupAurZup5y1PRh8Ismb1A3lLao',
  stripeApiKey:
    'pk_live_51O87KxAawgYYcPfzDdZ91X85Q4PRA1hZAWYZjmZxGQoXx5XXD5YNTy7d6qytt8I8WtTiFxoYgTbraoCwEGJpDsN200jAwzJNFC',
  production: true,
  firebase: {
    apiKey: 'AIzaSyAVfjRdd5GK9yFJx8jkFHrZP5OA1YGuWUc',
    authDomain: 'rfm-osp.firebaseapp.com',
    databaseURL: 'https://rfm-osp-default-rtdb.firebaseio.com',
    projectId: 'rfm-osp',
    storageBucket: 'rfm-osp.firebasestorage.app',
    messagingSenderId: '766752602477',
    appId: '1:766752602477:web:bc5b1474ebc26dc3b78264',
    measurementId: 'G-T8SF745TF7',
  },
  backendUrl: '',
};
